import {Col, Row,} from "antd";
import React, {useEffect, useState} from "react";
import {WdiPanelSelect, WdiSelect} from "@/components/WdiControls/WdiSelect";


export enum DateCustomizeType {
  CURRENT = 1,
  DYNAMIC = 2,
}

export const DateCustomizeTypeMap = new Map<DateCustomizeType, string>([
  [DateCustomizeType.CURRENT, "当期"],
  [DateCustomizeType.DYNAMIC, "动态日期"]
]);

export type DateCustomizeInputValue = {
  typeId?: DateCustomizeType,
  dynamicDateValue?: {
    startDay: number,
    endDay: number
  }
}

type RebateStandardDateCustomizeInputProps = {
  value?: DateCustomizeInputValue,
  onChange?: (value: DateCustomizeInputValue) => void
}


export const RebateStandardDateCustomizeInput: React.FC<RebateStandardDateCustomizeInputProps> = (props) => {
  const [customizeValue, setCustomizeValue] = useState<DateCustomizeInputValue>({});


  useEffect(() => {
    let customizeValueTemp = props.value ?? {};
    customizeValueTemp.dynamicDateValue = {
      startDay: customizeValueTemp.dynamicDateValue?.startDay ?? 1,
      endDay: customizeValueTemp.dynamicDateValue?.endDay ?? 31,
    }
    setCustomizeValue(customizeValueTemp);
  }, [props.value])

  const setDynamicDateRangeValue = (fieldName: string, value: number) => {
    const dynamicDateRange: any = customizeValue.dynamicDateValue ?? {};
    dynamicDateRange[fieldName] = value;
    customizeValue.dynamicDateValue = dynamicDateRange;
    props.onChange?.({...customizeValue});
  }

  const getDynamicDateInput = (fieldName: 'startDay' | 'endDay') => {
    const value = customizeValue?.dynamicDateValue?.[fieldName];
    return <WdiPanelSelect
      onBlur={() => {
        props.onChange?.(customizeValue)
      }}
      suffix={'▼'}
      prefix={' '}
      value={value ? value + '' : ''}
      splitSize={6}
      dataSource={Array.from({length: 31}).map((_v, i) => (i + 1) + '')}
      onChange={value => setDynamicDateRangeValue(fieldName, value)}
    />
  }

  return (<Row gutter={[16, 8]}>
    <Col span={24}>
      <WdiSelect
        value={customizeValue?.typeId}
        options={Array.from(DateCustomizeTypeMap.entries()).map(item => {
          return {
            value: item[0],
            label: item[1]
          }
        })}
        onChange={(value) => {
          setCustomizeValue({
            typeId: value,
            dynamicDateValue: customizeValue?.dynamicDateValue
          })
        }}
        onBlur={() => {
          props.onChange?.(customizeValue)
        }}
      />
    </Col>
    {/*动态日期 每月第*天 ~ 第*天*/}
    {DateCustomizeType.DYNAMIC == customizeValue.typeId && <Col span={24}>
      <Row style={{textAlign: "center"}}>
        <Col span={4}><span style={{fontSize: '18px'}}>{'每月第'}</span></Col>
        <Col span={4}>{getDynamicDateInput('startDay')}</Col>
        <Col span={2}><span style={{fontSize: '18px'}}>{'天\n'}</span></Col>
        <Col span={1}><span style={{fontSize: '18px'}}>{'~'}</span></Col>
        <Col span={2}><span style={{fontSize: '18px'}}>{'\n第'}</span></Col>
        <Col span={4}>{getDynamicDateInput('endDay')}</Col>
        <Col span={2}><span style={{fontSize: '18px'}}>{'天\n'}</span></Col>


      </Row>
    </Col>
    }
  </Row>)
}



